import React from 'react';

const TheRoomTheme = {
  headerLogo: {
    src: '/themes/theme/theroom/theroom-dark.png',
    alt: 'TheRoom influencers',
  },
  darkLogo: {
    src: '/themes/theme/theroom/theroom-light.png',
    alt: 'TheRoom influencers',
  },
  headerStyle: {
    backgroundColor: '#002a5a',
    borderBottom: '2px solid #000',
  },
  linkStyle: {
    color: '#FFF',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'THE ROOM | CAMPAIGNS',
  isLightOnDark: true,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="50" src="/themes/theme/theroom/theroom-light.png" alt="TheRoom Influencers" />
    </div>
  ),
  shareSite: 'https://reports.theroom.io',
  organisationId: '5bf5b36b-48cb-4d2a-a304-580db89965f9',
};

export default TheRoomTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/theroom.js
 **/